import React,{ useState }  from 'react';
import { Container, ThemeProvider } from '@material-ui/core';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Form from './Components/Form/Form';
import SignUp from './Components/Auth/SignUp/SignUp';
import Login from './Components/Auth/Login/Login';
import PostDetails from './Components/PostDetails/PostDetails';
import { createMuiTheme } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline';
;

let theme = createMuiTheme({
    typography: {
        
    }
});


const App = () => {
    const [currentId,setCurrentId] = useState(0);
    
    return(
    <BrowserRouter>
        <CssBaseline />
        <Container maxWidth="md">
            <ThemeProvider theme={theme}>
            <Navbar  setCurrentId={setCurrentId}/>
            <Switch>
                <Route path="/" exact component={() => <Redirect to="/posts" />} />
                <Route path='/posts' exact>
                    <Home currentId={currentId} setCurrentId={setCurrentId}/>
                </Route>
                <Route path='/posts/search' exact>
                    <Home currentId={currentId} setCurrentId={setCurrentId}/>
                </Route>
                <Route path='/posts/:id' exact>
                    <PostDetails currentId={currentId} setCurrentId={setCurrentId} />
                </Route>
                <Route path='/form' exact>
                    <Form currentId={currentId} setCurrentId={setCurrentId} />
                </Route>
                <Route path='/login' exact>
                    <Login />
                </Route>
                <Route path='/sign-up' exact>
                    <SignUp />
                </Route>
            </Switch>
            </ThemeProvider>
        </Container>
    </BrowserRouter>    
    )
}

export default App;